import { GetLogo, DeleteLogo } from '../../../../Services/FileService'
import { useConfig } from '../../../../Providers/ConfigProvider'
import { useAuth } from '../../../../Providers/AuthProvider'
import { toast } from 'react-toastify'

const useGetLogo = () => {
    const { api } = useConfig()
    const { authState, logout } = useAuth()

    const handleGetLogo = async () => {
        try {
            const logo = await GetLogo(api, authState.custId)
            return logo
        } catch (e) {
            console.log(e)
            return null
        }
    }

    const handleDeleteLogo = async () => {
        try {
            await DeleteLogo(api, authState.custId)
            return true
        } catch (e) {
            console.log(e)
            if (e.response.status === 403) {
                if (e.response.data.includes('Brak uprawnień')) {
                    toast.error('Brak uprawnień!')
                }
                else {
                    logout(false, false, true)
                }
            }
            return false
        }
    }

    return { handleGetLogo, handleDeleteLogo }
}

export default useGetLogo